var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#295F98",
    viewBox: "-1 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    stroke: "#295F98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.417 9.58A7.917 7.917 0 1 1 8.5 1.662a7.917 7.917 0 0 1 7.917 7.916zm-2.93.717L8.981 5.793A2.169 2.169 0 0 0 7.63 5.24l-2.635.026a.815.815 0 0 0-.801.8L4.163 8.71a2.166 2.166 0 0 0 .55 1.352l4.505 4.504a.794.794 0 0 0 1.12 0l3.148-3.15a.794.794 0 0 0 0-1.119zM5.724 6.25a.554.554 0 1 0 .554.554.554.554 0 0 0-.554-.554zm5.306 5.857a.396.396 0 0 1-.56 0l-.246-.246a1.853 1.853 0 0 1-.328.172 1.17 1.17 0 0 1-.465.091c-.034 0-.068 0-.103-.003a.396.396 0 0 1 .057-.79.428.428 0 0 0 .199-.025 1.125 1.125 0 0 0 .198-.102 1.683 1.683 0 0 0 .181-.142 1.004 1.004 0 0 0 .267-.47c.042-.199-.025-.266-.057-.298a.294.294 0 0 0-.186-.083.654.654 0 0 0-.221.024.875.875 0 0 0-.206.097.995.995 0 0 0-.164.134 2.094 2.094 0 0 1-.267.228 1.606 1.606 0 0 1-.422.216 1.305 1.305 0 0 1-.546.06 1.103 1.103 0 0 1-.669-.31 1.118 1.118 0 0 1-.275-1.063 1.688 1.688 0 0 1 .221-.522l-.24-.24a.396.396 0 1 1 .559-.56l.249.248a1.937 1.937 0 0 1 .343-.167 1.388 1.388 0 0 1 .485-.09.396.396 0 0 1 .001.792.595.595 0 0 0-.206.039 1.141 1.141 0 0 0-.208.1l-.02.012a1.122 1.122 0 0 0-.148.106 1.01 1.01 0 0 0-.264.457.334.334 0 0 0 .063.328.326.326 0 0 0 .19.082.528.528 0 0 0 .215-.023.837.837 0 0 0 .211-.109 1.324 1.324 0 0 0 .168-.144 1.793 1.793 0 0 1 .296-.24 1.679 1.679 0 0 1 .399-.187 1.454 1.454 0 0 1 .51-.058 1.082 1.082 0 0 1 .692.314 1.058 1.058 0 0 1 .27 1.022 1.703 1.703 0 0 1-.223.54l.25.251a.395.395 0 0 1 0 .56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.43f6d69e7386e61f0a3fe1884961b805.svg";
export { ForwardRef as ReactComponent };